import { IFetchSchoolBySearchQueryResponse } from "./schoolService.types";
import wretch from "wretch";
import { generateUUID } from "utils/utils";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_API;

export const fetchSchoolBySearchParams = (
  searchQuery: string
): Promise<IFetchSchoolBySearchQueryResponse> => {
  return wretch(`${BASE_URL}/theseus/api/v1/schools?search=${searchQuery}`)
    .headers({
      "x-iq-request-id": generateUUID()
    })
    .get()
    .json();
};
